import type { Specialist } from '../models/specialist';
import { apiGet } from './api-client';

/**
 * The consultants shown on the home page.
 *
 * Anonymous and rate-limited on the server, and its own route rather than a public flag on the
 * staff member list: that one answers an email address, a telephone number and a role.
 */
export async function getSpecialists(signal?: AbortSignal): Promise<Specialist[]> {
    return apiGet<Specialist[]>('/public/specialists', { signal });
}
